/*
 * @Author: Jing
 * @Date: 2021-11-05 13:33:19
 * @Descripttion:
 */
import fetch from './fetch'
import Qs from 'qs'
import { ResponseData } from '#/axios'
import remarkFetch from './remark'
import Cookies from 'js-cookie'
export function searchParams(form: any, params?: any): URLSearchParams {
    if (!params) params = new URLSearchParams()
    for (var key in form) {
        let val = form[key]
        if (val == undefined) continue
        if (Array.isArray(val)) {
            for (var i of val) {
                params.append(key, i)
            }
        } else {
            if (val instanceof File) {
                params.append(key, val)
            } else params.append(key, typeof val == 'object' ? JSON.stringify(val) : val)
        }
    }
    return params
}

// 扫码上传
const postUploadImg = <T>(uploadCode: string, files?: T): Promise<T> => {
    var params = new FormData()
    searchParams({ uploadCode, files }, params)

    return fetch.post('/clinic/order/doUpload', params, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    })
}

var headers = {
    'content-type': 'application/json;charset=utf-8',
}

// 发送验证码
const postSendCode = <T>(data?: T): Promise<T> => fetch.post('/wechat/account/securityCode/sendRandomCode', Qs.stringify(data))

const getSearchMember = <T>(billId: any, validCode: any): Promise<T> => fetch.get(`/wechat/user/account/other/phone/list/${billId}/${validCode}`)
const postBindMember = <T>(data?: T): Promise<T> => fetch.post('/wechat/user/account/adds', searchParams(data))

// 授权登录
const postLogin = <T>(data?: T): Promise<T> => fetch.post('/wechat/user/authCodeLogin', Qs.stringify(data))

const getAllClinic = () => fetch.get('/wechat/sec/hospital/queryHospList')
// 获取微信配置
const postWxConfig = <T>(data?: T): Promise<T> => fetch.post('/wechat/core/configSign', Qs.stringify(data))
// 发送验证码
const postSendValidCode = <T>(data?: T): Promise<T> => fetch.post('/patient/login/reg/v1/sendCode', data, { headers })
// 绑定手机号
const postBindPhone = <T>(data?: T): Promise<T> => fetch.post('/wechat/user/authLogin', Qs.stringify(data))

// 诊所列表
const getClinicList = <T>(data?: T): Promise<ResponseData> => fetch.get('/wechat/sec/hospital/queryAppointmentHosp', { params: data })
// 获取首页轮播
const getHomeLunbo = () => fetch.get('/patient/home/srvMp/initialize/v1')
// 获取诊所信息
// const getClinicInfo = (hospitalId: any) => fetch.get(`/clinic/order/self/hospital/${hospitalId}`)
const getClinicInfo = (hospitalId: any) => fetch.get(`/wechat/user/secHospital/${hospitalId}`)
// 挂号科室的获取
const getRegDeparts = (hospitalId: any) => fetch.get(`/clinic/usr/usrdoctorrank/today/hospitaldepart?hospitalId=${hospitalId}`)
// 挂号医生的获取
const getRegDocs = (departId: any, hospitalId: any) => fetch.get(`/clinic/usr/usrdoctorrank/today/doctor?hospitalId=${hospitalId}&departId=${departId}`)

// 诊所详情
const getHospital = (id: string | string[]) => fetch.get(`/wechat/user/secHospital/${id}`)
// 诊所医生列表
const getClinicDocList = (id: string | string[]) => fetch.get(`/wechat/user/doctor/list/${id}`)
// 诊所医生详情
const getClinicDocDetail = (hosId: string, docId: string) => fetch.get(`/wechat/user/doctorInfo/${hosId}/${docId}`)
// 医生排班信息
const getDoctorRank = (hid: string, did: string, start: string, end: string) => fetch.get(`/wechat/user/rank/${hid}/${did}`, { params: { startDate: start, endDate: end } })
// 体检报告列表
const getMedicalExamList = <T>(data: any): Promise<T> => {
    data.isMedicalExam = data.isMedicalExam ? data.isMedicalExam : 1
    return fetch.get('/wechat/order/MedicalExam/registeredList', { params: data })
}
// 体检报告详情
const getExamineReport = (id: string) => fetch.get('/wechat/order/report', { params: { registeredOrdId: id } })
// 查询报告单
const getReportList = <T>(data?: T): Promise<T> => fetch.get('/clinic/order/report/queryAllReport', { params: data })
// 门诊报告单详情
const getReportDetail = (regId: string) => fetch.get('/wechat/order/viewReport/' + regId)

// 诊所部门
const getClinicDepart = (id: string | number) => fetch.get(`/wechat/user/depart/doctor/${id}`)
// 获取成员列表
const getMembers = () => fetch.get('/wechat/user/account/phone/list')
// 获取成员账户
const getUserBookCount = (id: string | number) => fetch.get('/wechat/order/selectBookingCount', { params: { userId: id } })
const getMemberDiscount = (payOrderId: string | number, accountId: string | number) => fetch.post(`/wechat/order/calcPay/${payOrderId}`, Qs.stringify({ accountId: accountId }))
const getUserAccount = (id: string | number) => fetch.get(`/wechat/usr/user_account/${id}`)
const getUserInfo = (id: string | number) => fetch.get(`/wechat/user/account/get/user/${id}`)

const saveBook = (info: Object) => {
    var params = new FormData()
    searchParams(info, params)
    return fetch.post('/wechat/order/regBooking/rl', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
const getDepart = (hid: string | number, doctorId: string | number, endDate: string) =>
    fetch.get(`/wechat/user/depart/${hid}`, {
        params: {
            doctorId: doctorId,
            endDate: endDate,
        },
    })
const getDocDate = (hospitalId: string | number, departId: string | number, doctorId: string | number, startDate: string, endDate: string) =>
    fetch.get(`/wechat/user/depart/${hospitalId}/${departId}/${doctorId}`, {
        params: {
            startDate,
            endDate,
        },
    })

const getDocRankTime = (hospitalId: string | number, bookSettingId: string | number, startDate: string, endDate: string) =>
    fetch.get(`/wechat/user/depart/new/${hospitalId}/bookSettingId`, {
        params: {
            bookSettingId,
            startDate,
            endDate,
        },
    })
const getDoctorSet = (hosId: any, doctorId: any) => fetch.get(`/wechat/user/doctor/${hosId}/${doctorId}`)

const getDepartDoc = (hosId: string | number, departId: string | number, endDate: string) =>
    fetch.get(`/wechat/user/depart/${hosId}/${departId}`, {
        params: { endDate },
    })

// 预约类型
const getOutpatient = (hospitalId: string | number, settingBookingId: string | number, doctorId: string | number) =>
    fetch.get(`/wechat/user/UsrRegistrationFee/${settingBookingId}`, {
        params: { hospitalId, doctorId },
    })
const delMember = (relId: string | number) => fetch.post(`/wechat/user/account/del/${relId}`)
const postSetDefMember = (accountId: string | number) => fetch.post(`/wechat/user/account/defaultPerson/${accountId}`)

const postAddPatient = (body: Object) => {
    var params = new FormData()
    searchParams(body, params)
    return fetch.post('/wechat/user/account/new/people/add', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

const myBook = (page: string) => fetch.get(`/wechat/order/myRegBookingList?pageNo=${page}`)

const cancelBook = (bookingOrdId: string | number) =>
    fetch.post(
        `/wechat/order/cancelRegBooking/${bookingOrdId}?state=3`
        //     {
        //     params: {
        //         bookingOrdId,
        //         state: 3,
        //     },
        // }
    )

//预约详情
const getBookingDetail = (bookingOrdId: string | number) => fetch.get(`/wechat/order/getBooking/${bookingOrdId}`)

// 预约单获取单号详情
const getRegBookingDetails = (bookingOrdId: string) => fetch.get(`/wechat/order/myRegBookingList/byId?bookingOrdId=${bookingOrdId}`)

//省
const getProvince = () => fetch.get('/wechat/base/district/province')

//市
const getCity = (provCode: number) => fetch.get(`/wechat/base/district/city?parentCode=${provCode}`)

// 区
const getArea = (parentCode: number) => fetch.get(`/wechat/base/district/county?parentCode=${parentCode}`)

const getCaseList = (uid: string | number, pageNo: string | number) =>
    fetch.get('/wechat/order/elecOrdMedicalList', {
        params: {
            userId: uid,
            pageNo: pageNo,
        },
    })

const onlineCaseList = (userId: string | number, brandId: string | number, currentPage: string | number, pageSize: string | number) =>
    fetch.get('/wechat/ord/diagnose/patientDetailHistory.json', {
        params: { userId, brandId, currentPage, pageSize },
    })

// 儿保趋势图
const getHistoryPhy = (userId: string | number, column: string | number) => fetch.get(`/wechat/order/historyPhysique/${userId}/${column}`)

// 静态数据
const staticData = (codeType: string | number) =>
    fetch.get(`/clinic/base/staticData/list`, {
        params: { codeType },
    })

const getOrderPrescription = (regId: string | number, subjectType: string | number) =>
    fetch.get(`/wechat/order/prescriptionDetails/${regId}`, {
        params: { subjectType },
    })

// 儿保病历
const getChildCare = (registeredOrdId: string | number) =>
    fetch.get('/wechat/order/child-care', {
        params: { registeredOrdId },
    })

// 量表详情
const getScaleDetail = (registeredOrdId: string | number) =>
    fetch.get('/wechat/order/childcare/scale/query', {
        params: { registeredOrdId },
    })

const getCaseDetail = (registeredOrdId: string | number) => fetch.get(`/wechat/order/viewElecOrdMedicalList/${registeredOrdId}`)

const saveHistory = (uid: string | number, data: object) => {
    let form = { dataJson: data }
    let params = searchParams(form)
    return fetch.post(`/wechat/user/account/add/medicalInfo/${uid}`, params)
}

const healthHistory = (uid: string | number) => fetch.get(`/wechat/user/account/get/medicalInfo/${uid}`)

// 儿保首诊档案
const getChildProfile = (userId: string | number) =>
    fetch.get('/wechat/order/child-profile', {
        params: {
            userId,
        },
    })

// 病例信息——新
const getCaseDetailNew = (registeredOrdId: string | number) => fetch.get(`/user/emr/outpatient/viewElecOrdMedicalList/v1`, { params: { registeredOrdId } })

/**
 * 地址管理
 */
// 微信地址管理
const getAddressList = () => fetch.get('/wechat/address/queryAddress')
// 获取地址详情 {addressId}
const getAddress = <T>(data?: T): Promise<ResponseData> => fetch.post('/wechat/address/queryById', Qs.stringify(data))
// 添加、编辑地址
const postAddress = <T>(data?: T): Promise<T> => fetch.post('/wechat/address/saveOrUpdate', data)
// 删除地址
const delAddress = <T>(data?: T): Promise<T> => fetch.post('/wechat/address/deleteAddress', Qs.stringify(data))
// 查询默认地址
const getDefaultAddress = () => fetch.get('/wechat/address/getDefaultAddress')
// 设置默认地址 { addressId }
const postDefaultAddress = <T>(data?: T): Promise<T> => fetch.post('/wechat/address/setDefaultAddress', Qs.stringify(data))

/**
 * 订单管理
 * pageNo: page, userId: uid
 */
const getOrderWaitPayList = <T>(data?: T): Promise<T> => fetch.get('/wechat/order/registereds/waitPay', { params: data })
const getOrderHasList = <T>(data?: T): Promise<T> => fetch.get('/wechat/order/registereds/hasPay', { params: data })
const getOrderRefundList = <T>(data?: T): Promise<T> => fetch.get('/wechat/order/registereds/retreatPay', { params: data })
const getOrderDetail = (id: string) => fetch.get(`/wechat/order/feeDetails/waitPay/${id}`)
// const getOrderDetail = (type: string, id: string) => fetch.get(`/wechat/order/feeSummary/${type}/${id}`)
const getOrderState = (id: string) => fetch.get(`/wechat/order/registered/${id}`)

// 新收费start
// 已收费、退费
const getOrderPayList = <T>(uid: string, param?: T): Promise<T> => fetch.get(`/wechat/order/ordPay/hasPay/${uid}`, { params: param })
// 待支付详情
const getOrderWaitPayDetail = (regId: string) => fetch.get(`/wechat/order/feeDetails/waitPay/${regId}`)
// 已支付详情
const getOrderHasPayDetail = (regId: string, payId: string) => fetch.get(`/wechat/order/feeDetails/hasPay/${regId}/${payId}`)
// 已退款详情
const getOrderRePayDetail = (regId: string, payId: string) => fetch.get(`/wechat/order/feeDetails/retreatPay/${regId}/${payId}`)
// 新收费end

// 获取自定义匹配规格
const getConsumablesRules = (id: string) => fetch.get(`/wechat/ord/prod/select?hospitalId=${id}`)

/**
 * 账户
 */
// 获取会员信息
const getMemberAccount = (userId: string) => fetch.get(`/wechat/usr/user_account/${userId}`)
// 充值 { openId, paymentCode, payAmount, hospitalId }
const postRecharge = (userId: string, data: any) => fetch.post(`/clinic/usr/member/recharge/prePay/${userId}`, Qs.stringify(data))
// 账户记录
const getAccountList = (accountId: string, pageIndex: number, pageSize: number) => fetch.get(`/clinic/usr/member/balance/log/${accountId}`, { params: { pageIndex, pageSize } })
// 积分记录
const getAccountPoint = (accountId: string, pageIndex: number, pageSize: number) => fetch.get(`/clinic/usr/member/point/log/${accountId}`, { params: { pageIndex, pageSize } })
// // 会员权益
const getLevelDiscount = (level: string | number) => fetch.get(`/clinic/usr/member/levelDiscount/${level}`)
// 挂账记录
const getAccountCharge = <T>(data?: T): Promise<T> => fetch.get('/wechat/user/userBill/queryUserBillCount', { params: data })
// 挂账详情
const getAccountChargeDetail = (userId: string, hospitalId: string, pageNo: number) => fetch.get(`/wechat/order/listBillDetails/${userId}`, { params: { hospitalId: hospitalId, pageNo: pageNo } })

// 添加体征数据
const addPhysique = (userId: string | number, physique: object) => {
    let form = { physique: physique }
    let params = searchParams(form)
    return fetch.post(`/wechat/order/user/physique/${userId}`, params)
}

// 次卡购买记录
const getMemberOrderList = (userId: any, params: any): Promise<any> => fetch.get(`/clinic/usr/member/orderList/${userId}`, { params })

// 购买次卡订单列表详情里的执行列表
const getCardExecuteList = (id: any, pageIndex: any, pageSize: any): Promise<any> => fetch.get(`/clinic/usr/member/order/execute/${id}`, { params: { pageIndex, pageSize } })

// order 获取次卡详情
const getMemberDetails = (id: any) => fetch.get(`/clinic/usr/member/order/${id}`)

// 点评历史
const getCommentLog = (registeredOrdId: any) => fetch.get(`/clinic/order/registered/comment/${registeredOrdId}`)

// 上传电子签名
const uploadElecSign = ({ uploadCode, files }: any) => {
    var params = new FormData()
    searchParams({ uploadCode, files }, params)

    return fetch.post('/clinic/sec/oper/doUpload', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

// 手机端二维码后选择诊室提交（uuid=uuid data={token,诊室信息}）
const wechatConfirm = <t>(uuid: t, data?: t) => fetch.post('/clinic/sec/login/scanned', { uuid, data })

// 查询可登陆的账号
const getQrcodeOpers = () => fetch.get('/clinic/sec/login/account/opers')

// 二维码登陆
const qrcodeLogin = <t>(uuid: t, operatorId: t) => fetch.post('/clinic/sec/login/account', { uuid, operatorId })

// 自助机登录，获取诊所列表
export const searchPhoneInClinic = <T>(billId: T) => fetch.get('/clinic/sec/login/queryHosNames', { params: { billId: billId } })
// 自助机账号密码登录
export const selfHelplogin = (pwd: string, operatorId: string | number) => {
    var params = new FormData()
    let body = {
        source: 1,
        password: pwd,
        operatorId: operatorId,
    }
    searchParams(body, params)
    return fetch.post('/clinic/sec/login/user/1', params)
}
// 自助机账号密码登录 - 获取诊室
export const getAllDocRoom = () => fetch.get('/clinic/usr/room/getAllDocRoom')
// 自助机账号密码登录 - 选择诊室
export const saveSelectedClinic = (uuid: any, data: any) => {
    var params = new FormData()
    let body = {
        uuid: uuid,
        data: data,
    }
    searchParams(body, params)
    return fetch.post('/clinic/sec/login/put/uuid', params)
}

export {
    getRegDeparts,
    getRegDocs,
    getClinicInfo,
    postUploadImg,
    postBindMember,
    getSearchMember,
    postSendCode,
    postLogin,
    remarkFetch,
    postWxConfig,
    postSendValidCode,
    postBindPhone,
    getAllClinic,
    getClinicList,
    getHomeLunbo,
    getClinicDocList,
    getClinicDocDetail,
    getDoctorRank,
    getHospital,
    getClinicDepart,
    getMembers,
    getUserBookCount,
    getMemberDiscount,
    getUserAccount,
    getUserInfo,
    saveBook,
    getDepart,
    getDocDate,
    getDocRankTime,
    getDoctorSet,
    getDepartDoc,
    getOutpatient,
    delMember,
    postSetDefMember,
    postAddPatient,
    myBook,
    cancelBook,
    getBookingDetail,
    getProvince,
    getCity,
    getArea,
    getCaseList,
    onlineCaseList,
    getMedicalExamList,
    getReportList,
    getHistoryPhy,
    staticData,
    getOrderPrescription,
    getChildCare,
    getScaleDetail,
    getCaseDetail,
    saveHistory,
    healthHistory,
    getChildProfile,
    getCaseDetailNew,
    getAddressList,
    getAddress,
    postAddress,
    delAddress,
    getDefaultAddress,
    postDefaultAddress,
    getExamineReport,
    getReportDetail,
    getOrderWaitPayList,
    getOrderHasList,
    getOrderRefundList,
    getOrderDetail,
    getOrderState,
    getMemberAccount,
    postRecharge,
    getAccountList,
    getAccountPoint,
    getLevelDiscount,
    addPhysique,
    getAccountCharge,
    getAccountChargeDetail,
    // new
    getOrderPayList,
    getOrderWaitPayDetail,
    getOrderHasPayDetail,
    getOrderRePayDetail,
    // 次卡
    getMemberOrderList,
    getCardExecuteList,
    getMemberDetails,
    getCommentLog,
    uploadElecSign,
    wechatConfirm,
    getQrcodeOpers,
    qrcodeLogin,
    getRegBookingDetails,
    getConsumablesRules,
}
